import { useSavedReportFormik } from "@timenotes/shared/src/services/saved-reports/hooks/use-saved-report-formik"
import { TApiSavedReportFormObject } from "@timenotes/shared/src/services/saved-reports/saved-reports-types"
import { Modal, Radio } from "antd"
import TextField from "components/timenotes/fields/text-field"
import { Form, FormikProvider } from "formik"
import { usePagePermissions } from "hooks/permissions.hooks"
import { InputFieldWrapper } from "pages/projects/shared/components/project-form"
import { getSavedReportPath } from "../utils/get-saved-report-path"
import { useHistory } from "react-router-dom"
import { TextAreaField } from "components/timenotes/fields/text-area-field"

export interface SaveReportModalProps {
  savedReport: TApiSavedReportFormObject

  visible: boolean
  onCancel(): void
}

export const SaveReportModal = (props: SaveReportModalProps) => {
  const {
    savedReport,
    onCancel,
  } = props

  const history = useHistory()

  const { permissions } = usePagePermissions()

  const canCreateAdminSavedReport = !!permissions?.createAdminSavedReport

  const formik = useSavedReportFormik({
    initialValues: {
      ...savedReport,
    },
    onSuccess: (savedReport) => {
      formik.resetForm()
      onCancel()

      history.push(getSavedReportPath(savedReport))
    }
  })

  return (
    <FormikProvider value={formik}>
      <Modal
        destroyOnClose
        title="Saved Report"
        visible={props.visible}
        onOk={() => formik.submitForm()}
        onCancel={onCancel}
        okText="Save"
        okButtonProps={{
          disabled: !formik.isValid,
          loading: formik.isSubmitting,
        }}
      >
        <Form>
          <div style={{ marginBottom: '25px' }}>
            <InputFieldWrapper
              label="Name"
            >
              <TextField
                name="name"
                placeholder="Report name"
                autoFocusPopover
              />
            </InputFieldWrapper>
          </div>

          <div style={{ marginBottom: '25px' }}>
            <InputFieldWrapper
              label="Description"
            >
              <TextAreaField
                name="description"
                placeholder="Description"
              />
            </InputFieldWrapper>

          </div>
          { canCreateAdminSavedReport ? (
            <InputFieldWrapper
              label="Visibility"
            >
              <Radio.Group
                value={formik.values.visibility}
                onChange={(e) => formik.setFieldValue('visibility', e.target.value)}
              >
                <Radio value="private">Private (only visible to me)</Radio>
                <Radio value="admin">Admin (visible to all admins)</Radio>
              </Radio.Group>
            </InputFieldWrapper>
          ) : (
            <p>Saved report is private by default and visible only to you.</p>
          )}

        </Form>
      </Modal>
    </FormikProvider>
  )
}